import { BaseComponent2 } from '../../_common/client/base-component2';
import { addMoveTrackingToMoreReviewsButton } from './helper/add-move-tracking-to-more-reviews-button';
import { scrollToReviewsIfStarFilterIsSet } from './helper/scroll-to-reviews-if-star-filter-is-set';
import { registerOnSortSelectionChange } from './helper/register-on-sort-selection-change';
import { registerOnFilterEvent } from './helper/register-on-filter-event';
import { initializePagination } from './helper/pagination/initialize-pagination';
import { trackReviewCountOnPageImpression } from './helper/track-review-count-on-page-impression';

export class CustomerReviewListWrapperComponent extends BaseComponent2 {
    public rootSelector = '.js_cr_list-wrapper';

    public async init(): Promise<void> {
        if (!this.isPresent()) return;
        const rootElement = this.getRootElement();
        addMoveTrackingToMoreReviewsButton(rootElement);
        scrollToReviewsIfStarFilterIsSet(rootElement);
        initializePagination(rootElement);
        registerOnFilterEvent(rootElement);
        registerOnSortSelectionChange(rootElement);
        trackReviewCountOnPageImpression(rootElement);
    }
}
